var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorCarRental(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m38.071,14.748l-3.9-7.812c-.685-1.372-2.086-2.239-3.62-2.239H11.449c-1.533,0-2.935.867-3.62,2.239l-3.9,7.812c-.623,1.248-.948,2.625-.948,4.02v15.205c0,1.838,1.49,3.329,3.329,3.329s3.329-1.49,3.329-3.329v-.939h22.721v.939c0,1.838,1.49,3.329,3.329,3.329s3.329-1.49,3.329-3.329v-15.205c0-1.395-.324-2.772-.948-4.02Zm-25.507-5.693h16.808c.647,0,1.234.38,1.499.97l2.735,6.084c.235.522-.147,1.112-.719,1.112H9.048c-.572,0-.954-.59-.719-1.112l2.735-6.084c.265-.59.852-.97,1.499-.97Zm3.514,15.174c0,.982-.796,1.778-1.778,1.778h-4.965c-.982,0-1.778-.796-1.778-1.778h0c0-.982.796-1.778,1.778-1.778h4.965c.982,0,1.778.796,1.778,1.778h0Zm16.589,1.778h-4.965c-.982,0-1.778-.796-1.778-1.778h0c0-.982.796-1.778,1.778-1.778h4.965c.982,0,1.778.796,1.778,1.778h0c0,.982-.796,1.778-1.778,1.778Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorCarRental);
export default __webpack_public_path__ + "static/media/indoor-car_rental.2f8b3c2bd1f77537e33c7724521b034f.svg";
export { ForwardRef as ReactComponent };